import { OPERATIONAL_EVENT_TYPE } from '@atlassian/mpac-analytics';

// Partner Feedback

export const OPEN_FEEDBACK_COLLECTOR = 'openFeedbackCollector';
export const SUBMIT_FEEDBACK_COLLECTOR = 'submitFeedbackCollector';
export const DELETE_VERSION_SUBMIT = 'deleteVersionSubmit';
export const DELETE_VERSION_FAILURE = 'deleteVersionFailure';
export const ANALYTICS_APP_VERSION_EDIT_VIEW = 'appVersionEditView';
export const deleteVersionFailure = (actionSubjectId, attributes, source) => ({
  eventType: {
    action: 'failed',
    actionSubject: DELETE_VERSION_SUBMIT,
    details: 'Error occurs while deleting version',
    type: OPERATIONAL_EVENT_TYPE
  },
  source,
  actionSubjectId,
  attributes
});
export const deleteVersionSuccess = (actionSubjectId, attributes, source) => ({
  eventType: {
    action: 'success',
    actionSubject: DELETE_VERSION_SUBMIT,
    details: 'When version is deleted',
    type: OPERATIONAL_EVENT_TYPE
  },
  source,
  actionSubjectId,
  attributes
});